import { createSelector } from 'reselect';

import { selectUserPhones } from './selectUserPhones';

export const selectFirstAnyPhone = createSelector(selectUserPhones, phones => {
  if (phones) {
    return phones[0]?.phone ?? null;
  }

  return null;
});
